import { render, staticRenderFns } from "./PremiumOffers.vue?vue&type=template&id=1cad204c&scoped=true&"
import script from "./PremiumOffers.vue?vue&type=script&lang=js&"
export * from "./PremiumOffers.vue?vue&type=script&lang=js&"
import style0 from "./PremiumOffers.vue?vue&type=style&index=0&id=1cad204c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cad204c",
  null
  
)

export default component.exports